import { Entity } from '@backstage/catalog-model';
import { IdentityApi } from '@backstage/core-plugin-api';
import { CatalogApi } from '@backstage/plugin-catalog-react';

import { arrayToObjectReducer } from '../utils';

const getDefaultBranch = (entity: Entity) => {
  const branch =
    entity.metadata.annotations?.['backstage.io/source-location']?.split('/')[
      -2
    ] ?? 'main';
  return branch;
};

export const onboardTechDocsFormDataBuilder = async (
  entity: Entity,
  formFields: string[],
  _identityApi?: IdentityApi,
  _catalogApi?: CatalogApi,
) => {
  const formData = formFields
    .map((field: string) => {
      switch (field) {
        case 'repoName':
          return { [field]: entity.metadata.name };
        case 'defaultBranch':
          return {
            [field]: getDefaultBranch(entity),
          };
        default:
          return {};
      }
    })
    .reduce(arrayToObjectReducer, {});

  return formData;
};
